<template>
  <pp-container fluid>
    <h1 class="text-center">
      Visit
    </h1>
    <waiting-for-doctor v-if="isWaiting" />
    <video-container
      v-else
      :api-key="vonageApiKey"
      :session-id="serverState.videoSessionInfo.sessionId"
      :token="serverState.videoSessionInfo.publisherToken"
      @end="endCall"
      @publisherAccess="publisherAccessHandler"
    />
  </pp-container>
</template>

<script>
import WaitingForDoctor from '@/components/waiting-for-doctor/WaitingForDoctor'
import { VideoContainer, VISIT_STATES } from 'sdk-vue-telehealth-visit'
import { mapGetters, createNamespacedHelpers } from 'vuex'
import { LOCAL_STORAGE_CHANNEL_ID_KEY, LOCAL_STORAGE_CHANNEL_LAST_ACTIVE } from '@/constants'

const { mapState } = createNamespacedHelpers('visitSession')

export default {
  name: 'ViewsVisit',
  components: {
    WaitingForDoctor,
    VideoContainer
  },
  data () {
    return {
      vonageApiKey: process.env.VUE_APP_VONAGE_API_KEY,
      waitingTime: undefined
    }
  },
  computed: {
    ...mapState({
      connection: (state) => state.connection,
      serverState: (state) => state.clientStateSnapshot,
      channelId: (state) => state.channelId
    }),
    ...mapGetters({
      practiceInfo: 'practice/practiceInfo'
    }),
    isWaiting () {
      return (this.connection === 'CONNECTING' || this.serverState.visitState !== VISIT_STATES.ACTIVE)
    }
  },
  watch: {
    serverState: {
      deep: true,
      handler () {
        // if session is marked as completed then redirect user to thank you page
        if (this.serverState.visitState === VISIT_STATES.COMPLETED) {
          localStorage.removeItem(LOCAL_STORAGE_CHANNEL_ID_KEY)
          this.$router.push({ name: 'ViewsThankYou' })
        }

        // if session is marked as missed then redirect user to thank you page
        if (this.serverState.visitState === VISIT_STATES.MISSED) {
          localStorage.removeItem(LOCAL_STORAGE_CHANNEL_ID_KEY)
          this.$router.push(
            {
              name: 'ViewsThankYou',
              params: {
                missed: true
              }
            }
          )
        }
      }
    },
    isWaiting (newValue) {
      if (!newValue) {
        const timeWaited = Math.floor((Date.now() - this.waitingTime) / 1000)
        this.$ppAnalytics.trackEvent({
          action: 'start_call',
          label: this.serverState.appointmentType
        })
        this.$ppAnalytics.trackEvent({
          action: 'wait_time',
          label: this.serverState.appointmentType,
          value: timeWaited
        })
      }
    }
  },
  created () {
    setInterval(() => {
      this.sendIsActive()
    }, 1000)
    this.waitingTime = Date.now()
  },
  mounted () {
    this.$ppAnalytics.trackEvent({
      action: 'enter_waiting_room',
      label: this.serverState.appointmentType
    })
  },
  methods: {
    endCall () {
      this.$store.commit('visitSession/SET_STATE', {
        ...this.serverState,
        visitState: VISIT_STATES.COMPLETED,
        endCallTime: Date.now()
      })
      this.$ppAnalytics.trackEvent({
        action: 'end_call',
        label: this.serverState.appointmentType
      })
    },
    sendIsActive () {
      // send is active as message to provider channel
      const message = {
        channelId: this.channelId,
        isActive: Date.now()
      }
      this.$store.dispatch('visitSession/sendMessage', {
        message: JSON.stringify(message),
        channelId: `doc-${this.practiceInfo.practice_id}`
      })

      // store in local storage
      localStorage.setItem(LOCAL_STORAGE_CHANNEL_LAST_ACTIVE, Date.now())
    },
    publisherAccessHandler (e) {
      this.$ppAnalytics.trackEvent({
        action: 'media_permissions',
        label: e
      })
    }
  }
}
</script>
